module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.2.1-rc.1-92.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.2.1-rc.1.md
// module id = 508
// module chunks = 326